import { genMessage } from '../helper';
import antdLocale from 'ant-design-vue/es/locale/zh_CN';

const modules = import.meta.globEager('./zh-CN/**/*.ts');

console.log({...genMessage(modules, 'zh-CN')},"=============1")
console.log(antdLocale,"===========antdLocale==2")
export default {
  ...genMessage(modules, 'zh-CN'),
  antdLocale,
};
